import styled from 'styled-components/native';

import Image from '@src/components/Image';

type Props = {
  color?: string;
  size?: number;
};
const Component = styled(Image).attrs<Props>(({ color }) => ({
  tintColor: color,
}))<Props>`
  width: ${({ size = 24 }) => size}px;
  height: ${({ size = 24 }) => size}px;
`;

Component.displayName = 'ImageIcon';

export default Component;
